import { createInterfaceToken } from '@bmai/shared';
import type { ClassificationAssistPlan, ClassificationAssistRequest } from '@/shared/assist/ClassificationAssistContract';

/**
 * Turns a classification/policy ask into staged add/update suggestions. The
 * implementation calls the bmai-web BFF (`/_assist/classifications`), which runs the
 * suggestion through the generic telemetry structured-LLM endpoint grounded in the
 * tenant's existing classifications — no LLM SDK or model knowledge lives in the browser.
 */
export interface IClassificationAssistEngine {
    suggest(request: ClassificationAssistRequest): Promise<ClassificationAssistPlan>;
}

export const IClassificationAssistEngineToken = createInterfaceToken<IClassificationAssistEngine>('IClassificationAssistEngine');
